module.exports = __webpack_public_path__ + "img/package.52684402.png";